export enum FileOutputMode {
  OVERWRITE = "overwrite",
  APPEND_TIMESTAMP = "appendTimestamp",
}
